export default __webpack_public_path__ + "static/media/conversation-chat-bg.59ddcc02.svg";